<template>
  <!-- header here -->
  <header class="sticky-header">
    <header-top-vue />
    <div class="calc-new-header calc-appoitment">
      <div
        class="float-left header-icon-contain position-relative canel-add-icon"
      >
        <div class="d-inline float-left">
          <a href="#" @click.stop.prevent="goBack" class="color-red">
            <object
              class="svg-back-arrow"
              :data="backSvg"
              type="image/svg+xml"
            ></object>
          </a>
        </div>
      </div>

      <!-- Add appointment heading -->
      <div
        class="col-4-custom custom-title text-center"
        v-if="addOrEdit === 'ADD'"
      >
        <span class="main-title" @click.prevent.stop>Add Client</span>
      </div>

      <!-- Edit appointment heading -->
      <div class="col-4-custom custom-title text-center" v-else>
        <span class="main-title" @click.prevent.stop>Edit Client</span>
      </div>

      <div
        class="float-right header-icon-contain position-relative canel-add-icon"
      >
        <div class="d-inline float-right">
          <a
            v-if="addOrEdit === 'ADD'"
            href="#"
            @click.stop.prevent="addClientLocal"
            class="color-red cta-primary"
            >Save</a
          >
          <a
            v-else
            href="#"
            @click.stop.prevent="addClientLocal"
            class="color-red cta-primary"
            >Save</a
          >
        </div>
      </div>
    </div>
  </header>
  <!-- header ends here -->
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import HeaderTopVue from "../../common/HeaderTop.vue";

export default {
  props: {
    from: Object
  },
  computed: {
    ...mapGetters({
      showResultsNow: "getShowResultsNow",
      previousRoute: "getPreviousRoute"
    }),
    ...mapGetters("clients", {
      addOrEdit: "getMode"
    }),
    backSvg() {
      return require("../../../assets/svg/back.svg");
    }
  },
  methods: {
    ...mapMutations({
      preventRemoveResults: "preventRemoveResults"
    }),
    ...mapActions("clients", {
      addClient: "addClient"
    }),
    addClientLocal() {
      this.addClient(this.addOrEdit);
    },
    goBack() {
      if (this.showResultsNow) {
        this.preventRemoveResults();
      }
      if ("previousRoute" in this && this.previousRoute === "/") {
        this.$router.push("/daily");
        return;
      }
      this.$router.go(-1);
    }
  },
  components: {
    HeaderTopVue
  }
};
</script>

<style scoped>
.sub-title-wrapper {
  color: #ccc;
  font-size: 18px;
  font-weight: normal;
  margin: 0px;
  line-height: 36px;
}
.custom-title {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 50%;
}
.custom-title .main-title {
  display: inline-block;
  font-size: 18px;
  line-height: 36px;
}
@media screen and (max-width: 480px) {
  .custom-title .main-title {
    line-height: 32px;
  }
}
</style>
